export const title = 'TiDB User Group 会员申请';
export const description =
  '加入 TUG，让数据库、大数据从业者找到自己的圈子；' +
  '探索技术问题，随时随地交流成长，解决问题；发表技术见解，收获前沿知识，提升个人影响力。';
